import React from 'react';
import PropTypes from 'prop-types';
import Result from './Result';
import './DisplayArea.css';

function DisplayArea(props) {

  return (
      <section className="results" id="search-results" aria-live="polite">
        {props.loading &&
          <div className="loader">
            <i className="fa fa-spinner fa-pulse fa-3x" aria-hidden="true" title="Loading..."></i>
            <p>Loading Search Results...</p>
          </div>}
        <div className="articles">
          {props.data.map(result => <Result {...result} key={result.id} />)}
        </div>
      </section>
  );
}

DisplayArea.propTypes = {
  data: PropTypes.array.isRequired,
  resultCount: PropTypes.number.isRequired,
  searchTerm: PropTypes.string.isRequired,
};

export default DisplayArea;



// WEBPACK FOOTER //
// ./src/components/DisplayArea.js